import logoSrc from "../assets/buvant-logo.png";

/**
 * Buvant wordmark — the user's official transparent-PNG logotype.
 * The PNG is already tightly cropped to the glyphs (no padding), so height is
 * driven by font-size via the `className` (e.g. text-2xl); width auto-scales.
 */
export default function Logo({ className = "" }: { className?: string }) {
  return (
    <img
      src={logoSrc}
      alt="buvant"
      draggable={false}
      className={`inline-block w-auto select-none ${className}`}
      style={{ height: "1em" }}
    />
  );
}
